import React, { useState, useEffect } from "react";
import { CiMenuBurger } from "react-icons/ci";
import { FaCog, FaTimes, FaSignOutAlt } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../store/Reducer/AuthReducer";
import axios from "axios";

const Download = () => {
  const [companyName, setCompanyName] = useState("");
  const [productId, setProductId] = useState(""); //State to store entered product ID
  const [template, setTemplate] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [pdfUrl, setPdfUrl] = useState("");
  const [templateOptions, setTemplateOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [productNameData, setProductNameData] = useState([]); // State to store fetched product ID
  const [suggestions, setSuggestions] = useState([]);
  const [productName, setProductName] = useState(""); // Add productName state
  const [fileName, setFileName] = useState("download.pdf");
  const [blobFile, setBlobFile] = useState(null);

  const navigate = useNavigate();

  const { error, user } = useSelector((state) => {
    return state.auth;
  });
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchTemplateOptions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URI}/elixir/templates`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();

          if (data.templates && Array.isArray(data.templates)) {
            setTemplateOptions(data.templates);
          } else {
            console.error("Unexpected data format for template options:", data);
          }
        } else {
          console.error(
            "Error fetching template options:",
            response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching template options:", error);
      }
    };

    const fetchProductIds = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URI}/elixir/fetch_product`,
          {
            method: "GET",
            headers: { Accept: "application/json" },
            credentials: "include",
          }
        );

        if (response.ok) {
          const data = await response.json();

          if (data.data && Array.isArray(data.data)) {
            // Set the full product objects, not just IDs
            setProductNameData(data.data); // Store the entire array of products
          } else {
            console.error("Unexpected data format for product IDs:", data);
          }
        } else {
          console.error("Error fetching product IDs:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching product IDs:", error);
      }
    };

    fetchTemplateOptions();
    fetchProductIds(); // Fetch product data when the component mounts
  }, []);

  const handleProductNameChange = (e) => {
    const value = e.target.value;

    setProductName(value);

    if (value) {
      const filteredData = productNameData
        .filter((currElem) => {
          return currElem.product_name
            .toLowerCase()
            .includes(value.toLowerCase());
        })
        .map((element) => element.product_name);

      setSuggestions(filteredData);
    }
    if (value === "") {
      setSuggestions([]);
      setProductId("");
    }
  };

  const handleProductIdChange = (e) => {
    const value = e.target.value;
    setProductId(value);

    // Filter suggestions based on the product_id field
    if (value) {
      const filteredSuggestions = productNameData
        .filter((option) =>
          option.product_id.toLowerCase().includes(value.toLowerCase())
        )
        .map((option) => option.product_id); // Only map product_id for suggestions
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions([]); // Clear suggestions if input is empty
    }
  };

  const handleSuggestionSelect = (suggestion) => {
    setProductName(suggestion); // Set the product ID to the selected suggestion
    setSuggestions([]); // Clear suggestions after selection

    // Find the corresponding product object
    const selectedProduct = productNameData.find(
      (item) => item.product_name === suggestion
    );
    if (selectedProduct) {
      setProductId(selectedProduct.product_id); // Set the product name from the selected product
    }
  };

  const handleGenerateDocument = async (e) => {
    e.preventDefault();
    setLoading(true);

    const bodyData = {
      company_name: companyName,
      product_id: productId,
      template_name: template,
      customer_name: template === "LOCG" ? customerName : "",
    };

    try {
      // const response = await fetch(
      //   `${process.env.REACT_APP_BASE_URI}/elixir/generate_document`,
      //   {
      //     method: "POST",
      //     headers: {
      //       Accept: "application/json",
      //       "Content-Type": "application/json",
      //     },
      //     credentials: 'include',
      //     mode: "cors",
      //     body: JSON.stringify(bodyData),
      //   }
      // );

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URI}/elixir/generate_document`,
        bodyData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          withCredentials: true,
          responseType: "blob",
        }
      );

      // if (!response.ok) {
      //   const errorMessage = await response.json(); // Read error message from the response
      //   throw new Error(`${errorMessage[`detail`]}`);
      // }

      const blob = new Blob([response.data], {
        type: "application/pdf",
      }); // Get the PDF as a blob4
      // const metadata = { fileName: "example.txt", customKey: "customValue" };
      setBlobFile(blob);

      const url = URL.createObjectURL(blob); // Create a URL for the PDF blob
      // Extract filename from headers
 
      const contentDisposition = response.headers["x-file-name"];

      if (response.headers) {
        setFileName(contentDisposition);
      }

      setPdfUrl(url); // Display in iframe

      // Set up a hidden anchor element to override native download behavior
      // const downloadLink = document.createElement("a");
      // downloadLink.href = url;
      // downloadLink.download = filename; // Set correct filename
      // downloadLink.style.display = "none";
      // document.body.appendChild(downloadLink);
      // downloadLink.click();
      // document.body.removeChild(downloadLink);
      // URL.revokeObjectURL(url); // Clean up

      // // Detect when user clicks the browser's native download button
      // document.addEventListener("click", (event) => {
      //   const iframeElement = document.querySelector("iframe");
      //   if (iframeElement && iframeElement.contains(event.target)) {
      //     // When user clicks inside iframe, trigger the hidden download link
      //     setTimeout(() => downloadLink.click(), 500);
      //   }
      // });

      // Optional: Set the PDF URL for display in an iframe if necessary
      // setPdfUrl(url); // This allows you to display the PDF in an iframe without downloading

      toast.success("Document generated successfully!");
      // setSidebarOpen(!sidebarOpen)
    } catch (error) {
      console.error("Error:", error);

      // if(error.response){
      //   toast.info(`${error.response.data.detail}`);
      // }

      if (error.response && error.response.data instanceof Blob) {
        // Convert Blob to text and parse it as JSON
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const jsonResponse = JSON.parse(reader.result);
            const errorMessage = jsonResponse.detail || "An error occurred.";
            toast.info(errorMessage);
          } catch (parseError) {
            console.error("Error parsing JSON from Blob:", parseError);
            toast.error("Unexpected error format from server.");
          }
        };
        reader.readAsText(error.response.data);
      } else {
        toast.error("Unexpected error occurred.");
      }
    } finally {
      setLoading(false); // Stop the loading spinner
    }
  };

  const handleDownload = async () => {
    try {
      if (window.showSaveFilePicker) {
        const fileHandle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [
            {
              description: "PDF Files",
              accept: { "application/pdf": [".pdf"] },
            },
          ],
        });

        const writableStream = await fileHandle.createWritable();
        await writableStream.write(blobFile);
        await writableStream.close();

        toast.success(`Document saved as ${fileName}!`);
      } else {
        // Fallback to automatic download
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success("Document downloaded!");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        toast.info("Download cancelled.");
      } else {
        console.error("Error saving file:", error);
        toast.error("Failed to save file.");
      }
    }
  };

  const handleBackadmin = () => {
    navigate("/database");
  };

  const handleSignout = async () => {
    try {
      const res = dispatch(logoutUser({}));
      toast.success(res.data);
    } catch (error) {
      console.error("Error signing out:", error.message); // Log any sign-out errors
    }
  };

  function stripHtmlTags(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  }

  return (
    <div className="relative flex min-h-screen bg-gradient-to-r from-gray-800 via-gray-900 to-black">
      {/* Header */}
      <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-gray-900 to-gray-800 p-4 flex justify-between items-center shadow-lg z-10">
        <button
          className="mr-2"
          value={sidebarOpen}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <CiMenuBurger />{" "}
        </button>

        <div>
          <h1 className="text-white text-xl font-bold text-start self-start">
            Elixir
          </h1>
        </div>
        <div className="relative flex items-center space-x-4">
          <button
            onClick={handleBackadmin}
            className="outline-dotted outline-blue-600 hover:bg-blue-600 hover:outline-white ease-in-out transition-all duration-500 text-white p-2"
          >
            Back To Home Page
          </button>
          <FaCog
            className="text-white text-2xl cursor-pointer hover:text-gray-400 transition-colors"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          />
          {dropdownOpen && (
            <div className="absolute top-10 right-0 min-w-[200px] bg-gray-800 border border-gray-700 rounded-lg shadow-lg p-2">
              <button
                type="button"
                className="flex items-center text-red-500 p-2 hover:bg-gray-700 w-full text-left rounded-lg transition-colors"
                onClick={handleSignout}
              >
                <FaSignOutAlt className="mr-2" /> Sign Out
              </button>
            </div>
          )}
          {/* <FaBars
            className="text-white text-2xl cursor-pointer md:hidden"
            onClick={() => setSidebarOpen(true)}
          /> */}
        </div>
      </div>

      {/* Sidebar */}
      <motion.div
        initial={{ x: "-150%" }} // Start off-screen
        animate={{ x: sidebarOpen ? "0%" : "-300%" }} // Slide in/out based on state
        exit={{ x: "-100%" }} // Slide out on exit
        transition={{ duration: 0.3, ease: "easeInOut" }} // Smooth transition
        className={`top-0 h-screen bg-gray-800 bg-opacity-90 z-20 
              bg-gradient-to-b from-gray-800 to-gray-900
            text-white shadow-lg md:relative
            md:bg-gradient-to-b  max-sm:opacity-100 absolute sm:relative ${
              sidebarOpen ? "w-72 absolute p-6" : "w-0 left-[-80px] "
            }`}
      >
        <div className="flex flex-col mb-6">
          <FaTimes
            className="text-white text-md cursor-pointer mb-5"
            onClick={() => setSidebarOpen(false)}
          />
          <h2 className="text-2xl font-bold">Filters</h2>
        </div>
        <div className="flex flex-col gap-4">
          <div>
            <label htmlFor="company-name" className="block text-gray-300 mb-2">
              Company Name
            </label>
            <select
              id="company-name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              className="w-full p-2 border border-gray-700 rounded bg-gray-900 text-gray-200"
            >
              <option value="" disabled>
                Select a company
              </option>
              <option value="EI">Enzyme Innovation</option>
              <option value="SEB">Specialty Enzymes & Probiotics</option>
            </select>
          </div>

          <div>
            <label htmlFor="product-name" className="block text-gray-300 mb-2">
              Product Name
            </label>
            <input
              type="text"
              id="product-name"
              value={stripHtmlTags(productName)} // Bind the input to productName state
              onChange={handleProductNameChange}
              className="w-full p-2 border border-gray-700 rounded bg-gray-900 text-gray-200 "
            />
            {suggestions.length > 0 && (
              <div className="relative mt-1 ">
                <ul
                  className="absolute w-full bg-gray-900 border border-gray-700 rounded-md shadow-lg 
                  max-h-40 overflow-y-auto z-20"
                >
                  {" "}
                  {/* Change to absolute */}
                  {suggestions.map((suggestion) => (
                    <li
                      key={suggestion}
                      className="p-2 cursor-pointer hover:bg-gray-700"
                      onClick={() => handleSuggestionSelect(suggestion)}
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: suggestion }}
                      ></span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <div className="relative">
            {" "}
            {/* Add relative positioning to the parent div */}
            <label htmlFor="product-id" className="block text-gray-300 mb-2">
              Product ID
            </label>
            <input
              type="text"
              id="product-id"
              value={productId}
              onChange={handleProductIdChange}
              readOnly
              className="w-full p-2 border border-gray-700 rounded bg-gray-900 text-gray-400 cursor-not-allowed"
            />
          </div>

          <div>
            <label htmlFor="template" className="block text-gray-300 mb-2">
              Template
            </label>
            <select
              id="template"
              value={template}
              onChange={(e) => setTemplate(e.target.value)}
              className="w-full p-2 border border-gray-700 rounded bg-gray-900 text-gray-200"
            >
              <option value="" disabled>
                Select a template
              </option>
              {templateOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          {template === "LOCG" && (
            <div>
              <label
                htmlFor="customer-name"
                className="block text-gray-300 mb-2"
              >
                Customer Name
              </label>
              <input
                type="text"
                id="customer-name"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
                className="w-full p-2 border border-gray-700 rounded bg-gray-900 text-gray-200"
              />
            </div>
          )}

          <button
            onClick={handleGenerateDocument}
            className="bg-blue-600 text-white p-2 rounded hover:bg-blue-500 transition-colors"
          >
            {loading ? (
              <ClipLoader size={20} color="#ffffff" />
            ) : (
              "Generate PDF"
            )}
          </button>
          {pdfUrl && (
            <button
              onClick={handleDownload}
              className="bg-green-600 text-white p-2 rounded hover:bg-green-700 transition-colors"
            >
              {loading ? (
                <ClipLoader size={20} color="#ffffff" />
              ) : (
                "Download PDF"
              )}
            </button>
          )}
        </div>
      </motion.div>

      {/* PDF Viewer */}
      <div
        className={`flex-1 p-6 transition-all duration-300 w-full flex flex-col`}
      >
        {pdfUrl && (
          <div className="flex-1 mt-12 w-full overflow-hidden">
            <iframe
              src={pdfUrl}
              name="pdf-viewer"
              title="PDF File"
              className="w-full h-full border-none"
            />
          </div>
        )}
      </div>
      <ToastContainer theme="dark" />
    </div>
  );
};

export default Download;
